export default __webpack_public_path__ + "static/media/logo_transparent.57380993.png";